import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import Layout from '../components/Layout';
import { Box, Typography, Paper, Grid, CircularProgress } from '@mui/material';
import {
  DEFAULT_ADMIN_TILES,
  getAdminTileIcon,
  getAdminTileColors,
} from '../config/adminTileIcons';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [tiles, setTiles] = useState(null); // null while loading

  useEffect(() => {
    async function load() {
      try {
        const snap = await getDoc(doc(db, 'settings', 'adminTiles'));
        if (snap.exists() && snap.data().tiles?.length > 0) {
          const loaded = [...snap.data().tiles].sort(
            (a, b) => (a.order || 0) - (b.order || 0)
          );
          setTiles(loaded);
        } else {
          setTiles(DEFAULT_ADMIN_TILES);
        }
      } catch (e) {
        console.error('Failed to load admin tiles, using defaults:', e);
        setTiles(DEFAULT_ADMIN_TILES);
      }
    }
    load();
  }, []);

  if (tiles === null) {
    return (
      <Layout>
        <Box sx={{ textAlign: 'center', py: 8 }}><CircularProgress /></Box>
      </Layout>
    );
  }

  const visible = tiles.filter(t => t.enabled !== false);

  return (
    <Layout>
      <Box sx={{ p: 3 }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1E3A5F' }}>
            Administration
          </Typography>
          <Typography variant="body1" sx={{ color: '#888', mt: 0.5 }}>
            Manage your club settings, users, and content.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {visible.map((tile) => {
            const IconComp = getAdminTileIcon(tile.icon);
            const scheme = getAdminTileColors(tile.colorScheme);
            return (
              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={tile.key || tile.label}>
                <Paper
                  elevation={2}
                  onClick={() => tile.path && navigate(tile.path)}
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    backgroundColor: scheme.color,
                    cursor: tile.path ? 'pointer' : 'default',
                    transition: 'transform 0.15s, box-shadow 0.15s',
                    '&:hover': tile.path ? {
                      transform: 'translateY(-3px)',
                      boxShadow: 6,
                    } : {},
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5,
                    height: '100%',
                  }}
                >
                  <Box sx={{ color: scheme.iconColor }}>
                    <IconComp sx={{ fontSize: 36 }} />
                  </Box>
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1E3A5F' }}>
                      {tile.label}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', mt: 0.25 }}>
                      {tile.desc}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Layout>
  );
}
